import React,{ useCallback} from 'react';
import { MlsSideBar } from './Component/MlsSideBar';
import { Grid } from '@material-ui/core';
import { useStyles } from '../Module.styles';
import { Header } from '../../Components';
import { Outlet,useLocation} from 'react-router-dom';
import { ModuleContext, useModule } from '../../Context/ModuleContext/ModuleContext';
import clsx from 'clsx';
import { TabTitle } from '../../Utilities';
export const MlsModules=()=>{
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const location = useLocation();
    const handleSidebarToggle = useCallback((open: boolean) => {
        setOpen(open);
      }, []);
    const { Provider } = ModuleContext;
    let path:any;
    if(location?.pathname=="/ms/users/create-user"){
     let pathArray = location?.pathname?.split('/')
     path= pathArray[2];
    }else if(location?.pathname =="/ms/document/upload-document" ){
      let pathArray = location?.pathname?.split('/')
      path= pathArray[2];
    }else {
      let pathArray = location?.pathname?.split('/')
     path= pathArray[2];
    }
    const module = useModule();
    TabTitle(path)
    return(
      <Grid container>
        <Grid item>
          <MlsSideBar sidebarOpen={open} handleSidebarToggle={handleSidebarToggle} />
        </Grid>
        <Grid item className={clsx(classes.content,{ [classes.contentShift]: open })}>
          <Provider value={module}>
            <Header
              sidebarOpen={open}
              handleSidebarToggle={handleSidebarToggle}
             title={path}
              />
               <Outlet/>
        </Provider>
      </Grid>
      </Grid>
    )
} 